





































































import Breadcrumb from '@/components/Breadcrumb.vue';
import Component, {mixins} from 'vue-class-component';
import GeneralUtil from '@/util/GeneralUtil';
import {Prop, Ref} from 'vue-property-decorator';
import {
  BoardArticle,
  BoardArticleResponse,
  BV_OptionItemNumber,
  MemberInfo,
  PMSResGuestLogin,
  RepoPage,
  User,
} from '@/models';
import AXIOS from '../services/axios-wrapper';
import boardService from '../services/board.service';
import moment from 'moment';
import CONST from '@/util/Const';
import {Watch} from 'vue-property-decorator';
import MyHotelType from '@/pages/Reservation/hotelType';
import {HotelForeCastResult, hotelService, DateRange} from '@/services/hotel.service';
import {PMS_Res_HotelForecastListItem, PMS_YYYYMMDD, VCalendarAttrExp, VCalendarDateExp} from '@/models-hotel';
import {AxiosResponse} from 'axios';
import {namespace} from 'vuex-class';
import {DateUtil} from '@/util/DateUtil';
const Auth = namespace('Auth');

@Component({
  components: {
    GeneralUtil,
  },
})
export default class QuickReserv extends GeneralUtil {
  adultCnt = 2;
  childCnt = 0;

  v_datepicker_masks = {
    input: 'YYYY-MM-DD',
  };

  selectedDate = null;
  row = 1;
  col = 2;
  dal1 = 1;
  range: DateRange = {
    start: moment().toDate(),
    end: moment().add(1, 'd').toDate(),
  };

  result: HotelForeCastResult | null = null;
  closed = false;
  checkInStart: Date | null = null;
  checkOutEnd: Date | null = null;
  attrs: any = [];

  @Auth.Getter
  public isLoggedIn!: boolean;

  @Auth.Getter
  public isGuestLoggedIn!: boolean;

  @Auth.Action
  private guestLogin!: () => Promise<AxiosResponse<PMSResGuestLogin>>;

  get isAnnex() {
    return MyHotelType === 'A';
  }

  options_Cnt(otherOccupiedNum: number): BV_OptionItemNumber[] {
    let totalList = [
      {value: 0, text: '선택'},
      {value: 1, text: '1명'},
      {value: 2, text: '2명'},
      {value: 3, text: '3명'},
      {value: 4, text: '4명'},
      {value: 5, text: '5명'},
      {value: 6, text: '6명'},
    ];

    //포도의 경우에는 8인까지
    if (!this.isAnnex) {
      totalList.push({value: 7, text: '7명'}, {value: 8, text: '8명'});
      return totalList.slice(0, totalList.length - otherOccupiedNum);
    } else {
      // ANNEX 는 성인 최대 6명까지
      // ANNEX 최대 인원수 8명
      // return totalList.slice(0, totalList.length - otherOccupiedNum);
      return totalList.slice(0, 9 - otherOccupiedNum);
    }
  }

  get routeParam() {
    return {
      searchStart: this.date_today_yyyymmdd(this.range.start),
      searchEnd: this.date_today_yyyymmdd(this.range.end),
      adultCnt: String(this.adultCnt),
      childCnt: String(this.childCnt),
    };
  }

  get dayCount() {
    if (this.closed) return 0;
    return moment(this.range.end).diff(moment(this.range.start), 'days');
  }

  // @Watch('searchStart')
  // searchStartChanged(value: Date) {
  //   //console.log(value);
  //   if (this.dayCount <= 0 && !this.closed) {
  //     // 음수의 날짜가 될때 끝날짜를 1일 민다.
  //     // 1일 밀 수 없는 경우(잔여객실=0) 그냥 그대로 둔다 = 0박
  //     const endDayNextDay = moment(value).add(1, 'd');
  //     if (this.checkDayAvail(endDayNextDay)) this.range.end = endDayNextDay.toDate();
  //   }
  // }
  //
  // @Watch('searchEnd')
  // searchEndChanged(value: Date) {
  //   //console.log(value);
  //   if (this.dayCount <= 0 && !this.closed) {
  //     // 음수의 날짜가 될때 시작날짜를 1일 땡긴다.
  //     // 1일 땡길 수 없는 경우(잔여객실=0) 그냥 그대로 둔다 = 0박
  //     const startDayPrevDay = moment(value).add(-1, 'd');
  //     if (this.checkDayAvail(startDayPrevDay)) this.range.start = startDayPrevDay.toDate();
  //   }
  // }

  date_format(v: string) {
    //console.log(`isNan${v}isNan`);
    if (this.closed) return '예약불가';
    let m = moment(v);
    return `${m.format('M월 DD일')}(${this.dayOfWeek_short(m)})`;
  }

  created() {
    try {
      let guestLoginPm: Promise<AxiosResponse<PMSResGuestLogin>> | null = null;
      if (!this.isLoggedIn && !this.isGuestLoggedIn) {
        // 로그인 되어 있지 않다면 비회원 로그인 진행한다.
        guestLoginPm = this.guestLogin();
      }
      if (guestLoginPm) {
        guestLoginPm.then(() => {
          this.fetchHotelForecastList();
        });
      } else this.fetchHotelForecastList();
    } catch (e) {
      console.error(e);
    }
  }

  isValidDate(d: any) {
    return d instanceof Date && !isNaN(Number(d));
  }

  async fetchHotelForecastList() {
    this.result = await hotelService.fetchHotelForecastList(this.myMemType);

    let start_plus1 = moment(this.result.checkInStartDate).add(1, 'd').toDate();

    this.range = {
      start: this.result.checkInStartDate,
      end: start_plus1,
    };
    this.checkInStart = this.result.checkInStartDate;
    this.checkOutEnd = this.result.checkOutEndDate;

    this.attrs = [
      {
        highlight: {
          // style: {
          //   // Circle styles
          //   background: '',
          // },
          contentStyle: {
            // Text styles
            color: '#000000',
          },
        },
        dates: this.result.availDates,
      },
    ];

    if (!this.isValidDate(this.result.checkInStartDate)) {
      this.closed = true;
      console.log('closed');
      return;
    }
  }

  quickSearch() {
    // 설정 불가능한 날짜가 끼어있는지 검사한다.
    const checkJanSumRnageRes = hotelService.checkJanSumRange(
      this.range,
      this.result!.hotelForecastList!,
      this.showMsgBoxOk,
    );

    if (!checkJanSumRnageRes) {
      return;
    }
    this.$router.push({name: 'Realtimebooking2', params: {...this.routeParam}});
  }

  //hotelDatePicker에서 가져옴 computed

  $screens!: any;
  get layout() {
    return this.$screens({
      // Default layout for mobile
      default: {
        columns: 1,
        rows: 2,
      },
      // Override for large screens
      sm: {
        columns: 2,
        rows: 1,
        isExpanded: true,
      },
    });
  }

  handleInput() {
    this.$nextTick(() => {
      this.range = hotelService.calcBestFitDateRange(this.range, this.checkInStart!, this.checkOutEnd!);
    });
  }
}
